import { Model } from 'pinia-orm'

export default class ComponentImage extends Model {

    static get entity() {
        return 'component_images'
    }

    static get primaryKey() {
        return ['component_id', 'image_id'];
    }

    static fields() {
        return {
            component_id: this.attr(null),
            image_id: this.attr(null),
            order: this.attr(null),
        }
    }

    static formatBeforeSave(data, formdata) {
        if (typeof formdata.items === 'undefined' ||
            formdata.items.length === 0) {
            return data;
        }

        formdata.items.map((item, index) => {
            item.type = 'images';
            item.pivot = { order: item.order };
            delete item.order;
        });

        data.relationships = { images: { data: [...formdata.items] } };
        return data;
    }
}
